




















































































import { Vue, Component } from "vue-property-decorator";
import { has_value } from "@/utils/app-util";
import { countyCommunityMapModule } from "@/store/modules/countyCommunityMap";

// Interface 定義 (可選，但推薦用於 TypeScript)
interface CommunityItem {
  id: string;
  town: string;
  total: number;
  coords: { top: number; left: number };
  bp: number[];
  grip: number[];
  bmi: number[];
  frailty: number[];
}

@Component
export default class CountyCommunityMap extends Vue {
  // --- 狀態數據 ---
  public activePinId: string | null = null;
  public RYG_averages: { [key: string]: number[] } = {};

  // 滑鼠定位
  public mouseX = 0;
  public mouseY = 0;
  public showGuide = false;

  // Material Icons 定義
  public icons = [
    { iconContent: 'favorite', key: 'bp', title: '血壓', label: '血壓' },
    { iconContent: 'sports_mma', key: 'grip', title: '握力', label: '握力' },
    { iconContent: 'man', key: 'bmi', title: 'BMI', label: 'BMI' },
    { iconContent: 'directions_walk', key: 'frailty', title: '活動力', label: '走路或坐站' }
  ];

  non_null(value){
    return has_value(value);
  }

  get loading(){
    return countyCommunityMapModule.loading;
  }

  get request_time(){
    return countyCommunityMapModule.request_time;
  }

  get communityData() : CommunityItem[] {
    const rawMergedData = countyCommunityMapModule.communityData; 
    if (!rawMergedData || rawMergedData.length === 0) return [];
    
    // 現在只需將每個合併後的物件轉換為 Vue 組件所需的 RYGBL 陣列格式
    const transformedData: CommunityItem[] = rawMergedData.map((item: any) => ({
        id: item.fullcode,
        town: item.TOWNNAME,
        total: item.total,
        // 🚨 coords 已經由 Store 合併進來
        coords: { top: item.top, left: item.left }, 
        
        // 將 Key-Value 轉換為 RYGBL 陣列
        bp: [item.bp_red, item.bp_yellow, item.bp_green, item.bp_blue],
        grip: [item.grip_red, item.grip_yellow, item.grip_green, item.grip_blue],
        bmi: [item.bmi_red, item.bmi_yellow, item.bmi_green, item.bmi_blue],
        frailty: [item.frailty_red, item.frailty_yellow, item.frailty_green, item.frailty_blue], // frailty 轉換為 frailty
    }));
    
    return transformedData;
    }

  async created() {
    const displayAreaKeys = await countyCommunityMapModule.fetchPosData();
    await countyCommunityMapModule.getCommunity(displayAreaKeys);
    this.calculateAverages();
  }

  calculateAverages() {
    const metrics = ['bp', 'grip', 'bmi', 'frailty'];
    const totalCount = this.communityData.length;
    const sums: { [key: string]: number[] } = { bp: [0, 0, 0], grip: [0, 0, 0], bmi: [0, 0, 0], frailty: [0, 0, 0] };

    this.communityData.forEach(item => {
      metrics.forEach((metric) => {
        sums[metric][0] += item[metric][0]; // Red
        sums[metric][1] += item[metric][1]; // Yellow
        sums[metric][2] += item[metric][2]; // Green
      });
    });

    metrics.forEach(metric => {
      this.RYG_averages[metric] = sums[metric].map(sum => sum / totalCount);
    });
  }

  // 3. 判斷高覆蓋率 (藍色邊框)
  isHighCoverage(data: CommunityItem): boolean {
    // 藍色覆蓋率邏輯: 實測人數 (藍) > 總人數 / 2
    return (
      data.bp[3] > data.total / 2 &&
      data.grip[3] > data.total / 2 &&
      data.bmi[3] > data.total / 2 &&
      data.frailty[3] > data.total / 2
    );
  }

  // 4. 根據 R 計數回傳顏色類別 (更新邏輯: >=10 紅, >=5 黃)
  getMetricColorClass(RYGBL_data: number[]): string {
    const R_count = RYGBL_data[0]; 
    
    if (R_count >= 10) {
      return 'highlight-red';
    } 
    else if (R_count >= 5) {
      return 'highlight-yellow';
    } 
    return 'highlight-green'; 
  }

  // 新增：根據 B 計數回傳象限邊框類別
  getQuadrantBorderClass(RYGBL_data: number[], index: number): string {
    const B_count = RYGBL_data[3];
    const isBlue = B_count >= 5;
    return `quad-border-${index} ${isBlue ? 'blue-border' : 'default-border'}`;
  }

  updateMousePos(event: MouseEvent) {
    const container = event.currentTarget as HTMLElement;
    const rect = container.getBoundingClientRect();
    
    // 計算滑鼠在容器內的絕對像素位置
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    
    // 轉換為百分比 (0-100)，並取整數方便對應你的後端設定
    this.mouseX = Math.round((x / rect.width) * 100);
    this.mouseY = Math.round((y / rect.height) * 100);
  }
}
